import { Message } from "@/types/chat";
import { motion } from "framer-motion";
import { Bot, User } from "lucide-react";
import { cn } from "@/lib/utils";

interface ChatMessageProps {
  message: Message;
}

export function ChatMessage({ message }: ChatMessageProps) {
  const formatMessage = (content: string) => {
    return content.split('\n').map((paragraph, index) => (
      <p key={index} className="mb-2 last:mb-0 text-[15px] md:text-base">
        {paragraph}
      </p>
    ));
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.2 }}
      className={cn(
        "flex items-start gap-2 w-full",
        message.role === "assistant" ? "justify-start" : "justify-end"
      )}
    >
      {message.role === "assistant" && (
        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center ring-1 ring-primary/20">
          <Bot className="h-3 w-3 text-primary" />
        </div>
      )}
      <div className={cn(
        "flex flex-col gap-1 px-3 py-2 rounded-lg max-w-[85%] md:max-w-[75%] break-words",
        message.role === "assistant" 
          ? "bg-muted/50 text-foreground" 
          : "bg-primary text-primary-foreground ml-auto"
      )}>
        <div className="text-sm md:text-base leading-relaxed">
          {formatMessage(message.content)}
        </div>
        <span className="text-[10px] opacity-50 select-none">
          {new Date(message.created_at).toLocaleTimeString([], { 
            hour: '2-digit', 
            minute: '2-digit' 
          })}
        </span>
      </div>
      {message.role === "user" && (
        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-foreground/20 flex items-center justify-center ring-1 ring-primary-foreground/30">
          <User className="h-3 w-3 text-primary-foreground" />
        </div>
      )}
    </motion.div>
  );
}